import { sessionStorageKeys, STORAGE } from 'config/storage-config';
import { findPartnerLanding } from 'utils/getSessionStoragePartner';

export const initPartner = () => {
  const partnerLanding = findPartnerLanding(window.location);
  // For browser back from DS journey to any previous partner page except landing page
  // restore partner from browser history saved before leaving the partner journey
  // See: useHistoryNavigation
  const historyStatePartnerName = window.history.state?.state?.partnerName;
  const shouldRestorePartner = !!historyStatePartnerName;

  // restore partner from sessionStorage if it exists. See useOnExit saving partner before exiting
  if (shouldRestorePartner) {
    STORAGE.setItem(
      sessionStorageKeys.PARTNER_PATH,
      historyStatePartnerName,
      false
    );
  }

  if (partnerLanding) {
    STORAGE.setItem(sessionStorageKeys.PARTNER_PATH, partnerLanding, false);
  }
};
